<template>
  <div>
    <div style="font-size: 20px">รายการสินค้า</div>
    <v-expansion-panel focusable>
      <v-expansion-panel-content v-for="(item, i) in productdetails" :key="i">
        <template v-slot:header>
          <div>{{ item.product }}</div>
        </template>
        <div>
          <div class="mt-2 pa-3">
            <div v-if="item.photos && item.photos.length">
              <v-layout row wrap align-center>
                <v-flex xs3 sm3 class="pa-1" :key="k" v-for="(img, k) in item.photos">
                  <v-img aspect-ratio="1" :src="img" @click="openImage(img)">
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </v-flex>
              </v-layout>
            </div>
            <div v-if="item.format">
              <strong>รูปแบบการติดตั้ง:</strong>&nbsp;
              <span class="datalabel">{{ item.format }}</span>
            </div>
            <div>
              <strong>ซิงก์:</strong>&nbsp;<span class="datalabel">{{ item.sink }}</span>
            </div>
            <div v-if="item.HasDrillSink">
              <strong>เจาะซิงก์</strong>
              <div v-if="item.simplePhotoDrillSink && item.simplePhotoDrillSink.length">
                <v-layout row wrap align-center>
                  <v-flex
                    xs3
                    sm3
                    class="pa-1"
                    :key="k"
                    v-for="(img_sink, k) in item.simplePhotoDrillSink"
                  >
                    <v-img aspect-ratio="1" :src="img_sink" @click="openImage(img_sink)">
                      <template v-slot:placeholder>
                        <v-layout ma-0 fill-height justify-center align-center>
                          <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        </v-layout>
                      </template>
                    </v-img>
                  </v-flex>
                </v-layout>
              </div>
            </div>
            <div v-if="item.HasDrillStove">
              <strong>เจาะเตา</strong>
              <div v-if="item.simplePhotoDrillStove && item.simplePhotoDrillStove.length">
                <v-layout row wrap align-center>
                  <v-flex
                    xs3
                    sm3
                    class="pa-1"
                    :key="k"
                    v-for="(img_stove, k) in item.simplePhotoDrillStove"
                  >
                    <v-img aspect-ratio="1" :src="img_stove" @click="openImage(img_stove)">
                      <template v-slot:placeholder>
                        <v-layout ma-0 fill-height justify-center align-center>
                          <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        </v-layout>
                      </template>
                    </v-img>
                  </v-flex>
                </v-layout>
              </div>
            </div>
            <div>
              <strong>อุปกรณ์อื่นๆ:</strong>&nbsp;
              <span class="datalabel">{{ item.other }}</span>
            </div>
            <div>
              <strong>หมายเหตุ:</strong>&nbsp;
              <span class="datalabel">{{ item.remark || '-' }}</span>
            </div>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
export default {
  props: {
    productdetails: {
      type: Array
    }
  },
  data() {
    return {
      showImage: false,
      imageShow: null
    }
  },
  methods: {
    openImage(url) {
      window.open(url, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/kingKitchen/adminMenu/ProductDetailList.vue